import React from 'react'
import { DigitalVaultCompaniesAction, DigitalVaultDocumentAction, SyncfusionFileManagerAction } from '../../actions'
import './digital-vault-home.css'

const DigitalVaultHomeView = (props) => {
    // Check if we have a selectedDocument from navigation state (e.g., from tracking)
    const documentIdToUse = props.documentId || (props.selectedDocument && (props.selectedDocument.documentId || props.selectedDocument.id))

    if (documentIdToUse) {
        return (
            <DigitalVaultDocumentAction
                {...props}
                documentId={documentIdToUse}
                isFromDigitalVault={true}
                stateToMaintain={{
                    selectedCompany: props.selectedCompany,
                    selectedCategory: props.selectedCategory,
                    subcategoryPath: props.subcategoryPath,
                    selectedDocument: props.selectedDocument
                }}
            />
        )
    } else if (props.selectedCompany) {
        return <SyncfusionFileManagerAction {...props} />
    } else {
        return <DigitalVaultCompaniesAction {...props} />
    }
}

export default DigitalVaultHomeView